import reparentFieldSlice from './reparentFieldSlice';
import saveUploadedFieldShapeSlice from './saveUploadedFieldShapeSlice';

const fieldsSlices = [saveUploadedFieldShapeSlice, reparentFieldSlice];

export default fieldsSlices;
